import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";

// Components
import Select, { SelectOptionProps } from "components/atoms/Select";

// Hooks
import { useCurrency } from "hooks/useCurrency";

// Selectors

import { useCatalogsStore } from "stores/catalogs";
import { useGTM } from "../../hooks/useGTM";

const CurrencySelectContainer = () => {
  const currencies = useCatalogsStore((state) => state.currencies);
  const defaultCurrency = useCurrency();
  const GTM = useGTM();
  const { getValues, setValue, watch } = useFormContext();

  useEffect(() => {
    if (defaultCurrency) {
      setValue("currencyCode", defaultCurrency);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCurrency]);

  const handleSelect = (currency: string | number, { name }) => {
    const currencyCode = getValues(name);
    GTM.clickWheelCurrencyСhoice(currency);
    if (currencyCode === currency) {
      setValue(name, "");
    } else {
      setValue(name, currency);
    }
  };

  const currencyList = useMemo<SelectOptionProps[]>(() => {
    if (currencies) {
      return currencies?.map((item) => ({
        id: item.isoCode,
        name: item.isoCode,
      }));
    }
    return [];
  }, [currencies]);

  const value = watch("currencyCode");

  return (
    <Select
      name="currencyCode"
      options={currencyList}
      value={value}
      isSearchable
      onChange={handleSelect}
    />
  );
};

export default CurrencySelectContainer;
